import { render, staticRenderFns } from "./DTCLists.vue?vue&type=template&id=12379734&"
import script from "./DTCLists.vue?vue&type=script&lang=js&"
export * from "./DTCLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports